<template>
    <div>
        <site-header></site-header>
        <div class="c-t-not-found">
            <error-state v-bind="error"></error-state>
        </div>
        <site-footer></site-footer>
    </div>
</template>

<script>
    import SiteHeader from './components/organisms/OrganismSiteHeader.vue';
    import ErrorState from './components/molecules/MoleculeErrorState.vue';
    import SiteFooter from './components/organisms/OrganismSiteFooter.vue';

    export default {
        components: {
            SiteHeader,
            ErrorState,
            SiteFooter,
        },
        computed: {
            error: function() {
                return {
                    heading: 'Sidan finns inte',
                    body: `<p>Försöker du logga in: <a href="/logga-in/">klicka här</a></p><p>Eller klicka här för att komma till startsidan:</p>`,
                    type:'404',
                    button: {
                        label: 'Till startsidan',
                        icon: 'home',
                        classes: 'c-a-button--theme-primary',
                        to: '/'
                    }
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/NotFound.vue